import { SNACKBAR_MESSAGE } from './constants';

const initialState = {
  message: '',
  isActive: false,
};

export default (localState: any = initialState, action: any) => {
  switch (action.type) {
    case SNACKBAR_MESSAGE:
      if (action.payload) {
        const { status, localization } = action.payload;
        return {
          message: status,
          isActive: true,
          localization,
        };
      }
      return {
        ...localState,
        isActive: false,
      };
    default:
      return localState;
  }
};
